export enum Roles {
  CHALETADMIN = "chaletadmin",
  SECTORADMIN = "sectoradmin",
  CUSTOMERSERVICE = "customerservice",
}
